import * as apiConfig from '../../../verticals/hotels-dweb/src/shared/config/api-config';
import * as appConfig from '../../../verticals/hotels-dweb/src/shared/config/app-config';
import * as gaConfig from '../../../verticals/hotels-dweb/src/shared/config/ga-config';

export {apiConfig, appConfig, gaConfig};
